<div class="row" *ngIf="isComercial || isBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <!-- Linha 1  -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra
                                    <!-- <span class="InputRequired">{{required}}</span> -->
                                </mat-label>
                                <input matInput id="txtSafra" #txtSafra maxlength="8" formControlName="Safra"
                                    [readonly]="true" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtSafra.value.length}} / 8</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Safra)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                                <mat-select #txtSiteRecebimento formControlName="Site_recebimento"
                                    disableCenteringOption (selectionChange)="triggerContractAndSite()" disabled
                                    class="InputBlockColor">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterSiteRecebimento($event.target.value)">
                                    <mat-option *ngFor="let item of listSiteRecebimento" [value]="item.initials">
                                        {{item.initials | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Site_recebimento)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 2  -->

                    <div class="row pt-3">
                        <div class="col-lg col-md-9 col-xs-6 col-sm-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Cerar<span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtCerar" #txtCerar maxlength="17" formControlName="Cerar"
                                    (blur)="checkCerarExist()" (blur)="getHumidityData()" [readonly]="disableCerar"
                                    [class.InputBlockColor]="disableCerar">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="disableCerar"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!disableCerar"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtCerar.value.length}} / 17</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Cerar)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1 col-md-3 col-xs-6 col-sm-6 btnAlignSelf">
                            <button mat-flat-button color="primary" matTooltip="Leitor Cerar"
                                (click)="openDialog('Cerar')" class="btnSize" [disabled]="disableBtnCerar">
                                <i class="{{iconBarCodeField}}"></i> Leitor Cerar
                            </button>
                        </div>
                    </div>

                    <!-- Linha 3  -->

                    <div class="row pt-3">
                        <div class="col-lg col-md-9 col-xs-6 col-sm-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Ordem Rw<span
                                        class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtOrdemRw" #txtOrdemRw maxlength="20" currencyMask
                                    [options]="{ thousands: '', decimal: '', precision: 0 }" formControlName="Ordem_Rw">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintNumber}}</mat-hint>
                                <mat-hint align="end">{{txtOrdemRw.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Ordem_Rw)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1 col-md-3 col-xs-6 col-sm-6 btnAlignSelf">
                            <button mat-flat-button color="primary" matTooltip="Leitor Ordem" class="btnSize"
                                (click)="openDialog('Ordem')" [disabled]="disableBtnOrdem">
                                <i class="{{iconBarCodeField}}"></i> Leitor Ordem
                            </button>
                        </div>
                    </div>

                    <!-- Linha 4  -->

                    <div class="row pt-3">
                        <div class="col-lg col-md-9 col-xs-6 col-sm-6">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Jurídico<span
                                        class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtContrato" #txtContrato maxlength="16" (blur)="getDataPc003()"
                                    (blur)="triggerContractAndSite()" formControlName="Contrato_Juridico">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtContrato.value.length}} / 16</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Contrato_Juridico)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1 col-md-3 col-xs-6 col-sm-6 btnAlignSelf">
                            <button mat-flat-button color="primary" matTooltip="Leitor Contrato"
                                (click)="openDialog('Contrato')" class="btnSize" [disabled]="disableBtnContrato">
                                <i class="{{iconBarCodeField}}"></i> Leitor Contrato
                            </button>
                        </div>
                    </div>

                    <!-- Linha 5  -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Gleba
                                </mat-label>
                                <input matInput id="txtGleba" #txtGleba maxlength="1" formControlName="Gleba"
                                    [readonly]="readyOnlyGleba" [class.InputBlockColor]="readyOnlyGleba">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readyOnlyGleba"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readyOnlyGleba"></i>
                                <!-- <mat-hint align="start" class="InputLabelDetailsColor">Preenchimento Exclusivo para
                                    contratos Comerciais</mat-hint> -->
                                <mat-hint align="end">{{txtGleba.value.length}} / 1</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Gleba)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Origem</mat-label>
                                <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20" [readonly]="true"
                                    formControlName="Site_origem" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtSiteOrigem.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Site_origem)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 6  -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Cooperante</mat-label>
                                <input matInput id="txtCooperante" #txtCooperante maxlength="80" [readonly]="true"
                                    formControlName="Cooperante" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCooperante.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Cooperante)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Híbrido RNC/Linhagem</mat-label>
                                <input matInput id="txtHibrido" #txtHibrido maxlength="80" [readonly]="true"
                                    formControlName="Hibrido" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtHibrido.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Hibrido)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 7  -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Espécie</mat-label>
                                <input matInput id="txtEspecie" #txtEspecie maxlength="10" readonly
                                    formControlName="Especie" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Especie)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo Colheita</mat-label>
                                <input matInput id="txtTipoColheita" #txtTipoColheita maxlength="10" readonly
                                    formControlName="Tp_colheita" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTipoColheita.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tp_colheita)}}</mat-error>
                            </mat-form-field>
                        </div> -->
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo Colheita</mat-label>
                                <mat-select formControlName="Tp_colheita" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterTiposColheita($event.target.value)">
                                    <mat-option *ngFor="let item of listTiposColheita" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- linha 8 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração</mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="20" readonly
                                    formControlName="Geracao" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtGeracao.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Geracao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número do Campo</mat-label>
                                <input matInput id="txtNumCampo" #txtNumCampo maxlength="20" [readonly]="true"
                                    formControlName="Nr_campo" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtNumCampo.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Nr_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>



<div class="row" *ngIf="isPreBasica">
    <div class="col-lg col-md col-xs col-xl col-sm w-100">
        <mat-card class="mat-elevation-z8 w-100">
            <form [formGroup]="formulario" (keydown.enter)="$event.preventDefault()">
                <div class="row">
                    <div class="col-lg col-md col-xs col-xl col-sm">
                        <p class="tituloLeft">{{step}}</p>
                    </div>
                    <div class="col-lg-2 col-md-2 col-xs-2 col-xl-2 col-sm-2 text-right">
                        <i class="fa fa-window-minimize iconMenu" matTooltip="Minimizar" (click)="changeCollapse()"
                            *ngIf="!collapseCard"></i>
                        <i class="fa fa-window-maximize iconMenu" matTooltip="Maximizar" (click)="changeCollapse()"
                            *ngIf="collapseCard"></i>
                    </div>
                </div>
                <mat-card-content *ngIf="!collapseCard">
                    <!-- Linha 1  -->

                    <div class="row pt-3">



                        <div class="col-lg col-md" *ngIf="!isSafraBasica">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra</mat-label>
                                <mat-select #txtSafra formControlName="Safra" disableOptionCentering
                                    (selectionChange)="getDataPc003PreBasica(); calcHarvestWeek()">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..." (keyup)="createFilterSafra($event.target.value)">
                                    <mat-option *ngFor="let item of listSafra" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md" *ngIf="isSafraBasica">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Safra (Básica)</mat-label>
                                <input matInput id="txtSafraBasica" class="text-uppercase" txtSafraBasica maxlength="5"
                                    (blur)="converterSafra()" formControlName="Safra_basica">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Safra_basica)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Recebimento</mat-label>
                                <mat-select #txtSiteRecebimento formControlName="Site_recebimento"
                                    disableCenteringOption (selectionChange)="triggerContractAndSite()" disabled
                                    class="InputBlockColor">
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterSiteRecebimento($event.target.value)">
                                    <mat-option *ngFor="let item of listSiteRecebimento" [value]="item.initials">
                                        {{item.initials | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Site_recebimento)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 2  -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Cerar (Básica)<span
                                        class="InputRequired">{{required}}</span>
                                </mat-label>

                                <input matInput id="txtCerarBasica" #txtCerarBasica maxlength="10"
                                    formControlName="Cerar_basica" appOnlyNumberVirgula (blur)="checkCerarBasicaExist()"
                                    [readonly]="disableCerar" [class.InputBlockColor]="disableCerar">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="disableCerar"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!disableCerar"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtCerarBasica.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Cerar)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1 col-md-3 col-xs-6 col-sm-6 btnAlignSelf">
                            <button mat-flat-button color="primary" matTooltip="Leitor Cerar"
                                (click)="openDialog('Cerar_basica')" class="btnSize align-self-end"
                                [disabled]="disableBtnCerar">
                                <i class="{{iconBarCodeField}}"></i> Leitor Cerar
                            </button>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Lote Rw - Exemplo: E1DGRAO001 </mat-label>
                                <input matInput id="txtLoteRw" #txtLoteRw maxlength="10" formControlName="Lote_rw">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintLoteDsPet}}</mat-hint>
                                <mat-hint align="end">{{txtLoteRw.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Lote_rw)}}</mat-error>
                            </mat-form-field>
                        </div>


                    </div>

                    <!-- linha 5 -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Número de campo</mat-label>
                                <input matInput id="txtNumCampo" #txtNumCampo maxlength="20" [readonly]="false"
                                    formControlName="Nr_campo" appOnlyNumberVirgula (blur)=" converterSafra() ">
                                <!-- <i matSuffix class="{{iconDisableField}}" *ngIf="disableNumeroCampo"></i> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtNumCampo.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Nr_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Geração</mat-label>
                                <input matInput id="txtGeracao" #txtGeracao maxlength="20" readonly
                                    formControlName="Geracao" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtGeracao.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Geracao)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Contrato Jurídico<span
                                        class="InputRequired">{{required}}</span></mat-label>
                                <input matInput id="txtContrato" #txtContrato maxlength="16"
                                    formControlName="Contrato_Juridico" class="InputBlockColor" readonly>
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtContrato.value.length}} / 16</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Contrato_Juridico)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg-1 col-md-3 col-xs-6 col-sm-6 btnAlignSelf">
                            <button mat-flat-button color="primary" matTooltip="Leitor Contrato"
                                (click)="openDialog('Contrato')" class="btnSize align-self-end"
                                [disabled]="disableBtnContrato">
                                <i class="{{iconBarCodeField}}"></i> Leitor Contrato
                            </button>
                        </div>

                    </div>


                    <!-- Linha 3  -->

                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Gleba
                                </mat-label>
                                <input matInput id="txtGleba" #txtGleba formControlName="Gleba"
                                    [readonly]="readyOnlyGleba" [class.InputBlockColor]="readyOnlyGleba">
                                <i matSuffix class="{{iconDisableField}}" *ngIf="readyOnlyGleba"></i>
                                <i matSuffix class="{{iconEnableField}}" *ngIf="!readyOnlyGleba"></i>
                                <!-- <mat-hint align="start" class="InputLabelDetailsColor">Preenchimento Exclusivo para
                                    contratos Comerciais</mat-hint> -->
                                <mat-hint align="end">{{txtGleba.value.length}} / 1</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Gleba)}}</mat-error>
                            </mat-form-field>
                        </div>


                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Site Origem</mat-label>
                                <input matInput id="txtSiteOrigem" #txtSiteOrigem maxlength="20" [readonly]="true"
                                    formControlName="Site_origem" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtSiteOrigem.value.length}} / 20</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Site_origem)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Local de Produção/Cooperante</mat-label>
                                <input matInput id="txtCooperante" #txtCooperante maxlength="80" [readonly]="true"
                                    formControlName="Cooperante" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtCooperante.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Cooperante)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- Linha 4  -->

                    <div class="row pt-3">
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Híbrido RNC/Linhagem</mat-label>
                                <input matInput id="txtHibrido" #txtHibrido maxlength="80" [readonly]="true"
                                    formControlName="Hibrido" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtHibrido.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Hibrido)}}</mat-error>
                            </mat-form-field>
                        </div> -->

                        <div class="col-lg col-md">
                            <!--  novo campo Manufatura/linhagem -->
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Manufatura/linhagem</mat-label>
                                <input matInput id="txtManufatura" #txtManufatura maxlength="80" [readonly]="true"
                                    formControlName="hibrido_rnc" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtManufatura.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.hibrido_rnc)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Espécie</mat-label>
                                <input matInput id="txtEspecie" #txtEspecie maxlength="10" readonly
                                    formControlName="Especie" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Especie)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo Colheita</mat-label>
                                <input matInput id="txtTpColheita" #txtEspecie maxlength="10" readonly
                                    formControlName="Tp_colheita" class="InputBlockColor">
                                <!-- <mat-select formControlName="Tp_colheita" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterTiposColheita($event.target.value)">
                                    <mat-option *ngFor="let item of listTiposColheita" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtEspecie.value.length}} / 10</mat-hint>
                            </mat-form-field>
                        </div>
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tipo Colheita</mat-label>
                                <input matInput id="txtTipoColheita" #txtTipoColheita maxlength="10" readonly
                                    formControlName="Tp_colheita" class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTipoColheita.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tp_colheita)}}</mat-error>
                            </mat-form-field>
                        </div> -->

                    </div>


                    <!-- card parte II antigo -->
                    <div class="row  pt-3">
                        <!-- <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">(%) Umidade Cerar</mat-label>
                                <input matInput id="txtUmidade" #txtUmidade maxlength="5" formControlName="Umidade"
                                    currencyMask [options]="{ thousands: '.', decimal: ',', precision: 2 }"
                                    class="InputLabelDetailsColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                           
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <mat-hint align="end">{{txtUmidade.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Umidade)}}</mat-error>
                            </mat-form-field>
                        </div> -->

                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Nota de Ardida
                                    <span class="InputRequired">{{required}}</span>
                                </mat-label>
                                <input matInput id="txtArdida" #txtArdida maxlength="10" formControlName="nota_ardida">
                                <i matSuffix class="{{iconEnableField}}"></i>


                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtArdida.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.nota_ardida)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Data Colheita</mat-label>
                                <input matInput id="txtDataColheita" #txtDataColheita maxlength="20"
                                    formControlName="Dt_colheita" mask="d0/M0/0000" type="text"
                                    (blur)="makeCalculationsPreBasica(); calcHarvestWeek()"
                                    class="InputLabelDetailsColor">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtDataColheita.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Dt_colheita)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término enchimento Data</mat-label>
                                <input matInput id="txtTermEnchimentoData" #txtTermEnchimentoData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Termino_enchimento_data"
                                    (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtTermEnchimentoData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_enchimento_data)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Término enchimento Hora</mat-label>
                                <input matInput id="txtTermEnchimentoHora" #txtTermEnchimentoHora maxlength="5"
                                    mask="Hh:m0" formControlName="Termino_enchimento_hora"
                                    (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtTermEnchimentoHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Termino_enchimento_hora)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Saída Campo Data</mat-label>
                                <input matInput id="txtSaidaCampoData" #txtSaidaCampoData maxlength="10"
                                    mask="d0/M0/0000" formControlName="Saida_campo_data"
                                    (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintDate}}</mat-hint>
                                <mat-hint align="end">{{txtSaidaCampoData.value.length}} / 10</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Saida_campo_data)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Saída Campo Hora</mat-label>
                                <input matInput id="txtSaidaCampoHora" #txtSaidaCampoHora maxlength="5" mask="Hh:m0"
                                    formControlName="Saida_campo_hora" (blur)="makeCalculationsPreBasica()">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintHour}}</mat-hint>
                                <mat-hint align="end">{{txtSaidaCampoHora.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Saida_campo_hora)}}</mat-error>
                            </mat-form-field>
                        </div>




                    </div>
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Tempo de Espera Campo {{hintHourResult}}</mat-label>
                                <input matInput id="txtTempoEsperaCampo" #txtTempoEsperaCampo maxlength="5" readonly
                                    formControlName="Tempo_espera_campo" currencyMask class="InputBlockColor">
                                <i matSuffix class="{{iconDisableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintCalc}}</mat-hint>
                                <mat-hint align="end">{{txtTempoEsperaCampo.value.length}} / 5</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Tempo_espera_campo)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Respónsavel Liberação Colheita (RC)</mat-label>
                                <mat-select formControlName="Resp_liberacao_colheita" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterResponsavel($event.target.value)">
                                    <mat-option *ngFor="let item of listResponsavel" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>
                                <i matSuffix class="{{iconEnableField}}"></i>

                                <mat-error>{{hasErrorFormControl(formulario.controls.Resp_liberacao_colheita)}}
                                </mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                    <!-- card parte III antigo -->
                    <div class="row pt-3">
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Placa Carreta/Caminhão</mat-label>
                                <input matInput id="txtPlacaCarreta" #txtPlacaCarreta maxlength="7"
                                    formControlName="Placa_carreta">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">{{hintScoreBoard}}
                                </mat-hint>
                                <mat-hint align="end">{{txtPlacaCarreta.value.length}} / 7</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Placa_carreta)}}</mat-error>
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">Transportadora</mat-label>
                                <mat-select formControlName="Transportadora" disableCenteringOption>
                                    <input matInput type="text" class="form-control filterTxt"
                                        placeholder="Pesquisar por..."
                                        (keyup)="createFilterTransportadora($event.target.value)">
                                    <mat-option *ngFor="let item of listTransportadora" [value]="item.name">
                                        {{item.name | uppercase}}
                                    </mat-option>
                                </mat-select>

                                <!-- <input type="text" placeholder="Transportadora" matInput [matAutocomplete]="auto"
                                    formControlName="Transportadora" id="txtTransportadora" maxlength="20"
                                    #txtTransportadora>
                                <mat-autocomplete #auto="matAutocomplete">
                                    <mat-option *ngFor="let itemTransportadora of filteredOptions | async"
                                        [value]="itemTransportadora.name">
                                        {{itemTransportadora.name}}
                                    </mat-option>
                                </mat-autocomplete> -->
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor">
                                </mat-hint>
                                <!-- <mat-hint align="end">{{txtTransportadora.value.length}} / 20</mat-hint> -->
                            </mat-form-field>
                        </div>
                        <div class="col-lg col-md">
                            <mat-form-field class="w-100" appearance="{{formFieldAppearance}}"
                                floatLabel="{{formFieldFloatLabel}}">
                                <mat-label class="InputLabelColor">NFP Nota Fiscal</mat-label>
                                <input matInput id="txtNfpNotaFiscal" #txtNfpNotaFiscal maxlength="80"
                                    formControlName="Nfp_nota_fiscal">
                                <i matSuffix class="{{iconEnableField}}"></i>
                                <mat-hint align="start" class="InputLabelDetailsColor"></mat-hint>
                                <mat-hint align="end">{{txtNfpNotaFiscal.value.length}} / 80</mat-hint>
                                <mat-error>{{hasErrorFormControl(formulario.controls.Nfp_nota_fiscal)}}</mat-error>
                            </mat-form-field>
                        </div>
                    </div>

                </mat-card-content>
            </form>
        </mat-card>
    </div>
</div>